import baseRoute from '../baseRoute';

export default `${baseRoute}/itemCategory` as const;
